import request from '@/utils/request';

/**
 * 门店卡券（淘客后台）。
 *
 * 对应后端 DistributionStoreCardController，全部打 /admin/distribution/store/card/**，
 * 按登录账号绑定的门店过滤，不经过商户 mer_id。
 * storeId 由后端 DistributionStoreScope 兜底解析，前端一般不用传。
 */

/** 核销卡券：扫码传 codeToken，手动输入传 cardNo，二选一 */
export function storeCardVerifyApi(data) {
  return request({
    url: '/admin/distribution/store/card/verify',
    method: 'post',
    data: data
  });
}

/** 核销记录分页 */
export function storeCardVerifyRecordApi(params) {
  return request({
    url: '/admin/distribution/store/card/verify/record/list',
    method: 'get',
    params: params
  });
}

/** 已售卡券分页 */
export function storeCardListApi(params) {
  return request({
    url: '/admin/distribution/store/card/list',
    method: 'get',
    params: params
  });
}

/** 核销员列表，支持 keywords（昵称/手机号）和 status 筛选 */
export function storeCardVerifierListApi(params) {
  return request({
    url: '/admin/distribution/store/card/verifier/list',
    method: 'get',
    params: params
  });
}

/** 新增 / 启用 / 停用核销员：uid 和 phone 给一个就行 */
export function storeCardVerifierSaveApi(data) {
  return request({
    url: '/admin/distribution/store/card/verifier/save',
    method: 'post',
    data: data
  });
}

/** 移除核销员 */
export function storeCardVerifierDeleteApi(uid) {
  return request({
    url: '/admin/distribution/store/card/verifier/delete',
    method: 'post',
    params: {
      uid: uid
    }
  });
}

/** 撤销核销记录：data = { recordId, reason }，次数退回卡上 */
export function storeCardVerifyRevokeApi(data) {
  return request({
    url: '/admin/distribution/store/card/verify/revoke',
    method: 'post',
    data: data
  });
}